/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AdminProductListResponseDTO,
  CreateProductDTO,
  InProductDTO,
  OutAdminProductExtendedViewDTO,
  OutProductDTO,
  OutProductExtendedViewDTO,
  ProductListResponseDTO
} from "../models";
import {
  AdminProductListResponseDTOFromJSON,
  AdminProductListResponseDTOToJSON,
  CreateProductDTOFromJSON,
  CreateProductDTOToJSON,
  InProductDTOFromJSON,
  InProductDTOToJSON,
  OutAdminProductExtendedViewDTOFromJSON,
  OutAdminProductExtendedViewDTOToJSON,
  OutProductDTOFromJSON,
  OutProductDTOToJSON,
  OutProductExtendedViewDTOFromJSON,
  OutProductExtendedViewDTOToJSON,
  ProductListResponseDTOFromJSON,
  ProductListResponseDTOToJSON
} from "../models";

export interface CreateProductRequest {
  createProductDTO: CreateProductDTO;
}

export interface DeleteProductRequest {
  id: number;
}

export interface GetAllProductsRequest {
  platformId: number;
  skip: number;
  take: number;
}

export interface GetAllProductsExtendedRequest {
  skip: number;
  take: number;
  live?: string;
  platformId?: number;
  searchQuery?: string;
  sortBy?: GetAllProductsExtendedSortByEnum;
  sortOrder?: GetAllProductsExtendedSortOrderEnum;
}

export interface GetProductByIdRequest {
  id: number;
  extendedView: boolean;
}

export interface GetProductBySlugRequest {
  productSlug: string;
  platformId: number;
  extendedView: boolean;
}

export interface UpdateProductRequest {
  id: number;
  inProductDTO: InProductDTO;
}

/**
 *
 */
export class ProductsApi extends runtime.BaseAPI {
  /**
   */
  async createProductRaw(
    requestParameters: CreateProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutProductDTO>> {
    if (requestParameters.createProductDTO === null || requestParameters.createProductDTO === undefined) {
      throw new runtime.RequiredError(
        "createProductDTO",
        "Required parameter requestParameters.createProductDTO was null or undefined when calling createProduct."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/products`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateProductDTOToJSON(requestParameters.createProductDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutProductDTOFromJSON(jsonValue));
  }

  /**
   */
  async createProduct(
    requestParameters: CreateProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutProductDTO> {
    const response = await this.createProductRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async deleteProductRaw(
    requestParameters: DeleteProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteProduct."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/products/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteProduct(
    requestParameters: DeleteProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteProductRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllProductsRaw(
    requestParameters: GetAllProductsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProductListResponseDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getAllProducts."
      );
    }

    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getAllProducts."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getAllProducts."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/products`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProductListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getAllProducts(
    requestParameters: GetAllProductsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProductListResponseDTO> {
    const response = await this.getAllProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllProductsExtendedRaw(
    requestParameters: GetAllProductsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AdminProductListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getAllProductsExtended."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getAllProductsExtended."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.live !== undefined) {
      queryParameters["live"] = requestParameters.live;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.sortBy !== undefined) {
      queryParameters["sortBy"] = requestParameters.sortBy;
    }

    if (requestParameters.sortOrder !== undefined) {
      queryParameters["sortOrder"] = requestParameters.sortOrder;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/products/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getAllProductsExtended(
    requestParameters: GetAllProductsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AdminProductListResponseDTO> {
    const response = await this.getAllProductsExtendedRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getProductByIdRaw(
    requestParameters: GetProductByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutAdminProductExtendedViewDTO>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getProductById."
      );
    }

    if (requestParameters.extendedView === null || requestParameters.extendedView === undefined) {
      throw new runtime.RequiredError(
        "extendedView",
        "Required parameter requestParameters.extendedView was null or undefined when calling getProductById."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.extendedView !== undefined) {
      queryParameters["extendedView"] = requestParameters.extendedView;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/products/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutAdminProductExtendedViewDTOFromJSON(jsonValue));
  }

  /**
   */
  async getProductById(
    requestParameters: GetProductByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutAdminProductExtendedViewDTO> {
    const response = await this.getProductByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getProductBySlugRaw(
    requestParameters: GetProductBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutProductExtendedViewDTO>> {
    if (requestParameters.productSlug === null || requestParameters.productSlug === undefined) {
      throw new runtime.RequiredError(
        "productSlug",
        "Required parameter requestParameters.productSlug was null or undefined when calling getProductBySlug."
      );
    }

    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getProductBySlug."
      );
    }

    if (requestParameters.extendedView === null || requestParameters.extendedView === undefined) {
      throw new runtime.RequiredError(
        "extendedView",
        "Required parameter requestParameters.extendedView was null or undefined when calling getProductBySlug."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.extendedView !== undefined) {
      queryParameters["extendedView"] = requestParameters.extendedView;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/products/slug/{productSlug}`.replace(
          `{${"productSlug"}}`,
          encodeURIComponent(String(requestParameters.productSlug))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutProductExtendedViewDTOFromJSON(jsonValue));
  }

  /**
   */
  async getProductBySlug(
    requestParameters: GetProductBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutProductExtendedViewDTO> {
    const response = await this.getProductBySlugRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async updateProductRaw(
    requestParameters: UpdateProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutProductDTO>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateProduct."
      );
    }

    if (requestParameters.inProductDTO === null || requestParameters.inProductDTO === undefined) {
      throw new runtime.RequiredError(
        "inProductDTO",
        "Required parameter requestParameters.inProductDTO was null or undefined when calling updateProduct."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/products/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InProductDTOToJSON(requestParameters.inProductDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutProductDTOFromJSON(jsonValue));
  }

  /**
   */
  async updateProduct(
    requestParameters: UpdateProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutProductDTO> {
    const response = await this.updateProductRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetAllProductsExtendedSortByEnum = {
  noDealsSince: "noDealsSince"
} as const;
export type GetAllProductsExtendedSortByEnum =
  typeof GetAllProductsExtendedSortByEnum[keyof typeof GetAllProductsExtendedSortByEnum];
/**
 * @export
 */
export const GetAllProductsExtendedSortOrderEnum = {
  ASC: "ASC",
  DESC: "DESC"
} as const;
export type GetAllProductsExtendedSortOrderEnum =
  typeof GetAllProductsExtendedSortOrderEnum[keyof typeof GetAllProductsExtendedSortOrderEnum];
